// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header .ios ion-toolbar {
  --padding-top: calc(var(--ion-safe-area-top, 0) + 4px);
}
ion-header ion-toolbar {
  --background:white;
  --border-style: none;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
ion-header .main-toolbar {
  display: flex;
}
ion-header .main-toolbar .main-toolbar-title {
  font-size: 18px;
  text-align: left;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}
ion-header .main-toolbar .main-toolbar-title.buttons-safe-area {
  padding-left: 50px;
}
ion-header .main-toolbar .main-toolbar-title.buttons-safe-area.modal-title {
  padding-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/main-header/main-header.component.scss"],"names":[],"mappings":"AACI;EACQ,sDAAA;AAAZ;AAEI;EACI,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,4BAAA;AAAR;AAEI;EAEI,aAAA;AADR;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,2CAAA;AAAZ;AACY;EACI,kBAAA;AAChB;AACY;EACI,kBAAA;AAChB","sourcesContent":["ion-header{\n    .ios ion-toolbar {\n            --padding-top: calc(var(--ion-safe-area-top, 0) + 4px);\n        }\n    ion-toolbar {\n        --background:white;\n        --border-style: none;\n        padding-right: 0px !important;\n        padding-left: 0px !important;\n    }\n    .main-toolbar {\n        // height: 50px;\n        display: flex;\n        .main-toolbar-title {\n            font-size: 18px;\n            text-align: left;\n            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n            &.buttons-safe-area {\n                padding-left: 50px;\n            }\n            &.buttons-safe-area.modal-title {\n                padding-left: 15px;\n            }\n        }\n        \n    }\n    \n   \n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
